import { ReactNode } from 'react';

// Бэк отдаёт ссылки в ячейках строкой вида <a href='https://...' target='_blank'>текст</a>.
// Разбираем только этот формат и собираем ссылку через React, всё остальное выводим текстом:
// в ячейках бывает пользовательский ввод (имя, email, utm), и как HTML его вставлять нельзя.
// href — либо http(s)://, либо без схемы вовсе, чтобы не пропустить javascript: и data:
const BACKEND_LINK_RE =
  /^<a href=(['"])(https?:\/\/[^'"<>\s]+|[^'"<>\s:]+)\1 target=(['"])_blank\3>([^<>]*)<\/a>$/i;

const ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#039;': "'",
  '&#39;': "'",
  '&nbsp;': ' ',
};

export const decodeEntities = (value: string): string =>
  value.replace(/&(amp|lt|gt|quot|#039|#39|nbsp);/g, (entity) => ENTITIES[entity]);

export const parseBackendLink = (value: unknown): { href: string; text: string } | null => {
  const match = String(value ?? '').trim().match(BACKEND_LINK_RE);
  return match ? { href: decodeEntities(match[2]), text: decodeEntities(match[4]) } : null;
};

export const renderCellHtml = (value: unknown): ReactNode => {
  const link = parseBackendLink(value);
  if (link) {
    return (
      <a href={link.href} target="_blank" rel="noopener noreferrer">
        {link.text}
      </a>
    );
  }
  return decodeEntities(String(value ?? ''));
};
